import { ValidateEventFxn } from 'common.types'
import { VoterRegSuccessScreen, VoterRegErrorScreen } from '../components'
import { VoterRegPartialSuccessScreen } from '../components/VoterRegPartialSuccessScreen'
import { globalStore } from '../../../../stores/GlobalStore'

/**
 *
 * @param step
 * @param apiResponse
 * @param setReplacementContent
 * @returns {boolean} If `true`, then form continues to next step
 */
const validateVoterRegEvent: ValidateEventFxn = (
  step,
  apiResponse,
  setReplacementContent,
  setState,
  type,
) => {
  const setSuccessFlag = (flag: boolean, mibToo?: boolean) => {
    const globalState = globalStore?.state
    globalStore.setState({
      ...globalState,
      formEvents: {
        ...(globalState.formEvents ?? {}),
        voterRegistrationSubmitSuccess: flag,
        mailInBallotSubmitSuccess: mibToo ? true : false,
      },
    })
  }
  const { serverResponse } = apiResponse
  if (type === 'submit') {
    const { errors, applicationId, ovrMailinBallotApplicationId } =
      serverResponse?.data?.data?.response
    if (
      errors.length < 1 ||
      errors[0].length < 1 ||
      Object.values(errors[0])?.[0] === ''
    ) {
      setReplacementContent(<VoterRegSuccessScreen />)
      setSuccessFlag(true, ovrMailinBallotApplicationId ? true : false)
      return true
    }
    if (applicationId) {
      setReplacementContent(<VoterRegPartialSuccessScreen />)
      setSuccessFlag(true)
    } else {
      setReplacementContent(<VoterRegErrorScreen />)
      setSuccessFlag(false)
    }
    return true
  }
  return true
}
export default validateVoterRegEvent
